var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { ItemTreeNode, ItemTreeService } from './item-tree.service';
var ItemCategoryTreeComponent = /** @class */ (function (_super) {
    __extends(ItemCategoryTreeComponent, _super);
    function ItemCategoryTreeComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.all_events = [
            'init.jstree',
            'loading.jstree',
            'loaded.jstree',
            'ready.jstree',
            'load_node.jstree',
            'load_all.jstree',
            'model.jstree',
            'redraw.jstree',
            'before_open.jstree',
            'open_node.jstree',
            'after_open.jstree',
            'close_node.jstree',
            'after_close.jstree',
            'open_all.jstree',
            'close_all.jstree',
            'enable_node.jstree',
            'disable_node.jstree',
            'hide_node.jstree',
            'show_node.jstree',
            'hide_all.jstree',
            'show_all.jstree',
            'activate_node.jstree',
            'hover_node.jstree',
            'dehover_node.jstree',
            'select_node.jstree',
            'changed.jstree',
            'deselect_node.jstree',
            'select_all.jstree',
            'deselect_all.jstree',
            'set_state.jstree',
            'refresh.jstree',
            'refresh_node.jstree',
            'set_id.jstree',
            'set_text.jstree',
            'create_node.jstree',
            'rename_node.jstree',
            'delete_node.jstree',
            'move_node.jstree',
            'copy_node.jstree',
            'cut.jstree',
            'copy.jstree',
            'paste.jstree',
            'clear_buffer.jstree',
            'set_theme.jstree',
            'show_stripes.jstree',
            'hide_stripes.jstree',
            'show_dots.jstree',
            'hide_dots.jstree',
            'show_icons.jstree',
            'hide_icons.jstree',
            'show_ellipsis.jstree',
            'hide_ellipsis.jstree',
            'disable_checkbox.jstree',
            'enable_checkbox.jstree',
            'check_node.jstree',
            'uncheck_node.jstree',
            'check_all.jstree',
            'uncheck_all.jstree',
            //		"show_contextmenu.jstree",
            'search.jstree',
            'clear_search.jstree',
            'state_ready.jstree'
        ];
        _this.plugins = [
            'wholerow',
            'checkbox',
            'search',
            //"contextmenu",
            'dnd'
        ];
        _this.tree_data = new Subject();
        _this.ignore_events = ['hover_node.jstree', 'dehover_node.jstree'];
        _this.is_control_tree_monitor = false;
        _this.move = [];
        return _this;
    }
    ItemCategoryTreeComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.element = this.treeElement.nativeElement;
        this.init();
    };
    ItemCategoryTreeComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        if (this.cols.length > 0 && this.component.params && this.component.params.horizontal === true) {
            for (var _i = 0, _a = this.cols; _i < _a.length; _i++) {
                var col = _a[_i];
                $.extend(true, col, { params: { formClass: { horizontal: true } } });
            }
        }
    };
    ItemCategoryTreeComponent.prototype.tree = function () {
        return $(this.element).jstree(true);
    };
    ;
    ItemCategoryTreeComponent.prototype.init = function () {
        var _this = this;
        var self = this;
        this.tree_data.subscribe(function (data) {
            var tree = self.tree();
            if (!tree) {
                $(self.element).jstree({
                    core: {
                        check_callback: true,
                        data: data,
                        themes: {
                            icons: false,
                            stripes: true,
                        }
                    },
                    checkbox: {
                        keep_selected_style: false,
                        whole_node: false,
                        tie_selection: false,
                        visible: false
                    },
                    search: {
                        show_only_matches: true
                    },
                    dnd: {
                        large_drop_target: true,
                        large_drag_target: true
                    },
                    plugins: _this.plugins
                });
            }
            else {
                tree.settings.core.data = data;
                $(self.element).jstree('refresh');
            }
        });
        var events = this.all_events.filter(function (element) {
            return _this.ignore_events.indexOf(element) == -1;
        });
        $(this.element).on(events.join(' '), function (e, data) {
            self.onEvent(e, e.type, data);
        });
    };
    ItemCategoryTreeComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    ItemCategoryTreeComponent.prototype.onSubscribe = function (rec) {
        if (rec instanceof Array) {
            this.org_data = rec;
            this.applyToTreeData(rec);
            this.treeSearch = '';
            this.onChangeSearch('');
            this.move = [];
            var postData = {};
            postData.items = this.move;
            this.action.setRec(postData);
        }
    };
    ItemCategoryTreeComponent.prototype.applyToTreeData = function (recs) {
        var data = [];
        for (var _i = 0, recs_1 = recs; _i < recs_1.length; _i++) {
            var rec = recs_1[_i];
            data.push(new ItemNode(rec));
        }
        this.is_control_tree_monitor = true;
        this.tree_data.next(data);
        this.is_control_tree_monitor = false;
    };
    ItemCategoryTreeComponent.prototype.onEvent = function (e1, e2, rec) {
        if (e2 === 'move_node') {
            this.onMoveNode(rec);
        }
    };
    ItemCategoryTreeComponent.prototype.onMoveNode = function (rec) {
        this.move.push({
            operation: 'move',
            params: {
                id: rec.node.id,
                from: (rec.old_parent === '#' ? 0 : rec.old_parent),
                to: (rec.parent === '#' ? 0 : rec.parent),
                order: rec.position
            }
        });
        var postData = {};
        postData.items = this.move;
        this.action.setRec(postData);
    };
    ItemCategoryTreeComponent.prototype.openAll = function () {
        $(this.element).jstree('open_all');
    };
    ItemCategoryTreeComponent.prototype.closeAll = function () {
        $(this.element).jstree('close_all');
    };
    ItemCategoryTreeComponent.prototype.children = function (data, arr) {
        arr.push(data.id);
        for (var _i = 0, _a = data.children; _i < _a.length; _i++) {
            var child = _a[_i];
            this.children(child, arr);
        }
    };
    ItemCategoryTreeComponent.prototype.onSubmit = function (e, rec) {
        this.action.setRec(rec);
        this.action.firstAction(e);
    };
    ItemCategoryTreeComponent.prototype.onChangeSearch = function (value) {
        this.tree().search(value);
    };
    ItemCategoryTreeComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.tree_data.unsubscribe();
    };
    ItemCategoryTreeComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'unit',
                    template: "<form id=\"{{ componentName }}\">\n  <p>{{ (msg | async)['ItemCategoryTreeComponent.label.note1'] }}</p>\n  <div>\n    <input type=\"text\" class=\"checkTree_searchInput\" placeholder=\"{{ (msg | async)['Search...'] }}\" name=\"treeSearch\" [(ngModel)]=\"treeSearch\" (keyup)=\"onChangeSearch($event.target.value)\">\n    <a href=\"javascript:void(0);\" (click)=\"openAll()\">{{ (msg | async)['ItemCategoryTreeComponent.openAll'] }}</a>\n    <a href=\"javascript:void(0);\" (click)=\"closeAll()\">{{ (msg | async)['ItemCategoryTreeComponent.closeAll'] }}</a>\n  </div>\n  <div #tree></div>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    ItemCategoryTreeComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ItemTreeService }
    ]; };
    ItemCategoryTreeComponent.propDecorators = {
        treeElement: [{ type: ViewChild, args: ['tree',] }]
    };
    return ItemCategoryTreeComponent;
}(ContentBaseComponent));
export { ItemCategoryTreeComponent };
var ItemNode = /** @class */ (function (_super) {
    __extends(ItemNode, _super);
    function ItemNode(rec) {
        var _this = _super.call(this, rec) || this;
        if (rec['id'] != null) {
            _this.id = rec.id;
            rec.node_id = _this.id;
        }
        if (rec['disp_order'] != null) {
            _this.disp_order = rec.disp_order;
        }
        if (rec != null) {
            if (rec['children'] != null) {
                for (var _i = 0, _a = rec['children']; _i < _a.length; _i++) {
                    var child = _a[_i];
                    _this.children.push(new ItemNode(child));
                }
            }
        }
        return _this;
    }
    return ItemNode;
}(ItemTreeNode));
//# sourceMappingURL=item-category-tree.component.js.map